import { CanDeactivate } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { AppStorage } from '@/_storage';
import { NovatiqPopupHelper, UnsavedChangesHelper } from '@/_helpers';

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard implements CanDeactivate<any> {
  private readonly dataStorage = inject(AppStorage);
  private readonly popupService = inject(NovatiqPopupHelper);
  private readonly unsavedChangesHelper = inject(UnsavedChangesHelper);

  canDeactivate() {
    if (this.dataStorage.ContainsKey('EditMode')) {
      this.popupService.open('unsavedChanges');
      return this.unsavedChangesHelper.checkUnsavedChanges();
    } else {
      return true;
    }
  }
}
